<div class="app-modal-title">
	<div [ngSwitch]="processType">
		<ng-container *ngSwitchCase="'Upload'">Errors found in uploading process</ng-container>
		<ng-container *ngSwitchCase="'QC'">Errors found in QC process</ng-container>
		<ng-container *ngSwitchCase="'UploadWithQC'">Errors found in Upload & QC processes</ng-container>
	</div>
</div>
<div class="app-modal-content">
	<div class="error-messages">
		<div *ngFor="let err of errors">{{err.print}}</div>
	</div>
</div>
<div class="app-modal-footer">
	<div class="button-group">
		<!-- <button class="button-general" md-raised-button (click)="dialogRef.close(true)"></button> -->
		<button class="button-general" md-raised-button (click)="dialogRef.close()">Ok</button>
	</div>
</div>